import { render, staticRenderFns } from "./MainDetailForReview.vue?vue&type=template&id=ccb2221e&scoped=true&"
import script from "./MainDetailForReview.vue?vue&type=script&lang=js&"
export * from "./MainDetailForReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb2221e",
  null
  
)

export default component.exports